import { SoftwareAddonTemplate } from "../../../lib/model/addonTemplate";
import vatsimLogo from "../../images/templates/vatsim.png";

export const vatsimTemplate: SoftwareAddonTemplate = {
  type: "software",
  id: "vatsim",
  title: "VATSIM",
  platforms: ["msfs", "xplane", "p3d", "fsx"],
  image: vatsimLogo,
  content: [
    {
      title: "Flight Planning",
      roles: ["flightPlanning"],
      content: [
        { item: "VATSIM Client", setting: "Started" },
        { item: "VATSIM Flight Plan", setting: "Filed" },
      ],
    },
    {
      title: "Before simulator start",
      roles: ["beforeSimStart", "beforeSimFlightStart", "cockpitPreparation", "beforeFlightStart"],
      content: [{ item: "VATSIM Client", setting: "Connected" }],
    },
  ],
};
